const tr = {
    en: {
        title: "Subscriptions are being used by someone else\u2026",

        usedByPrompt: "The subscriptions from <b> {{brand}} </b> account <b> {{msisdn}} </b> are being used by another Now E account: <b> {{ottid}} </b>",

        transferPrompt: "Switch to use with current Now E account: <b> {{ottid}} </b>?",

        okBtnTxt: "OK",
        cancelBtnTxt: "Cancel",
    },
    zh: {
        title: "服務正於其他帳戶上使用\u2026",

        usedByPrompt: "您透過<b> {{brand}} </b>帳戶<b> {{msisdn}} </b>訂購的服務正於另一個Now E帳戶上使用: <b> {{ottid}} </b>",

        transferPrompt: "確定切換至Now E帳戶<b> {{ottid}} </b>以使用服務嗎?",

        okBtnTxt: "確定",
        cancelBtnTxt: "取消",
    }
}

export default tr;